import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ContratoItem from '../contratoItem/contratoItem';
import ContratoServico from '../contratoServico/contratoServico';
import consts from '../consts';
import { setError } from '../common/toast/toast';
import imagemAdd from '../assets/images/icone_add_imagem.png';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';

import {
	setModoTela, initForm
} from './contratoActions';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

class ContratoForm extends Component {

	state = {

	}

    componentWillMount() {
		
		let initSeletorAnexo = () => {
			const fileSelectorAnexo = document.createElement('input');
			fileSelectorAnexo.setAttribute('type', 'file');
			fileSelectorAnexo.addEventListener("change", (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('application/pdf')
						&& !file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PDF, .PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {


						let lista = (this.props.formularioValues.anexos || []).map(item => item);
						lista.push({
							arquivo_base64: reader.result
						});

						this.props.initForm({
							...this.props.formularioValues,
							anexos: lista
						});

						initSeletorAnexo();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorAnexo = fileSelectorAnexo;
		};

		initSeletorAnexo();

    }

    render() {

		let readOnly = this.props.excluir || this.props.convenio ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Select
								name='ids_grupo_faturamento'
								options={this.props.listaGrupoFaturamento}
								label='Grupos de Faturamento *'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly}
								multiple
								value={this.props.formularioValues.ids_grupo_faturamento}
								onChange={values => {
									this.props.initForm({
										...this.props.formularioValues,
										ids_grupo_faturamento: values.map(item => item.value)
									});
								}} />

							<Field
								name='id_hospital'
								component={Select}
								options={this.props.listaHospital}
								label='Hospital *'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={this.props.formularioValues.id ? 'readOnly' : readOnly} />

							<LabelAndInputDate
								maxWidth={180}
								name='data_inicio'
								label='Data Inicial *' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								value={this.props.formularioValues.data_inicio}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										data_inicio: value
									});
								}} />
							
							<LabelAndInputDate
								maxWidth={180}
								name='data_fim'
								label='Data Final' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								value={this.props.formularioValues.data_fim}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										data_fim: value
									});
								}} />
						</Row>

						{!this.props.convenio &&
						<Row>
							<Field
								maxWidth={220}
								name='percentual_reajuste'
								component={LabelAndInputNumber}
								label='Percentual de Reajuste' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								casas={2} />

							<Field
								maxWidth={220}
								name='percentual_imposto_escritorio'
								component={LabelAndInputNumber}
								label='Percentual Administração' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								casas={2} />
							
							<Field
								name='salvar_paciente'
								component={LabelAndCheckbox}
								label='Salvar dados do paciente na importação' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />
							
							<Field
								maxWidth={220}
								name='horario_comercial_inicio'
								component={LabelAndInputMask}
								label='Início Horário Comercial' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								mask={'99:99'}
								type='text' />
							
							<Field
								maxWidth={220}
								name='horario_comercial_fim'
								component={LabelAndInputMask}
								label='Fim Horário Comercial' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								mask={'99:99'}
								type='text' />
							
							<Field
								maxWidth={220}
								name='horario_plantao_inicio'
								component={LabelAndInputMask}
								label='Início do Horário de Plantão' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								mask={'99:99'}
								type='text' />

							<Field
								maxWidth={220}
								name='horario_plantao_fim'
								component={LabelAndInputMask}
								label='Fim do Horário de Plantão' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								mask={'99:99'}
								type='text' />
						</Row>}
						{!this.props.convenio &&
						<Row>							
							<LabelAndInputDate
								maxWidth={180}
								name='data_feriado'
								label='Feriados' placeholder='Informe'
								cols='8 6 4 3'
								readOnly={readOnly}
								value={this.props.formularioValues.data_feriado}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										data_feriado: value
									});
								}} />
							
							<button 
								type='button'
								style={{ height: 38, width: 38, marginTop: 29 }}
								class='btn btn-outline-dark btn-block'
								disabled={!this.props.formularioValues.data_feriado}
								onClick={() => {
									
									let listaFeriados = (this.props.formularioValues.feriados || []).map(feriado => feriado);
									listaFeriados.push(this.props.formularioValues.data_feriado)

									this.props.initForm({
										...this.props.formularioValues,
										feriados: listaFeriados,
										data_feriado: null
									});
								}}>
								<i class='fa fa-plus'></i>
							</button>
						</Row>}
						{!this.props.convenio &&
						<Row>
							<Grid cols='12 12 12 12'>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
									}}>
									{(this.props.formularioValues.feriados || []).map(feriado => (
										<div key={feriado}
											style={{
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												paddingTop: 4,
												paddingLeft: 12,
												paddingBottom: 4,
												paddingRight: 12,
												marginRight: 4,
												backgroundColor: '#005ca9',
												color: '#ffffff',
												borderRadius: 10
											}}>
											<div style={{ marginRight: 8 }}>{DateFormat.formatarDataSqlParaTela(feriado)}</div>
											<i 
												class='fa fa-times' 
												style={{ cursor: 'pointer', fontSize: 20 }}
												onClick={() => {
													this.props.initForm({
														...this.props.formularioValues,
														feriados: (this.props.formularioValues.feriados || []).filter(feriadoAux => feriadoAux != feriado)
													});
												}}>
											</i>
										</div>
									))}
								</div>
							</Grid>
						</Row>}

						<Row>
							<Field
								name='exames_ignorar'
								component={LabelAndInput}
								label='Exames Ignorados'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly} />
						</Row>

						{!this.props.convenio &&
						<Row style={{ marginLeft: 2 }}>
							<Grid cols='12 12 12 12'>

								<Row style={{ paddingBottom: 16 }}>
									<Grid cols='12 12 12 12'>
										<label>Anexos</label>
									</Grid>
									{(this.props.formularioValues.anexos || []).map(arquivo => (
										<div style={{ display: 'flex', flexDirection: 'column' }}>
											<span class="btn btn-outline-primary fileinput-button dz-clickable">
												<img src={arquivo.arquivo_base64 ? pdfAdicionado : (arquivo.arquivo ? pdfAdicionado : pdfAdd)} style={{ height: 30 }} />
											</span>
											<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
												<button
													type='button'
													class='btn btn-flat btn-outline-primary'
													style={{ width: '48%' }}
													disabled={arquivo.arquivo_base64 ?true : false}
													onClick={() => {
														window.open(`${consts.URL}/${arquivo.file}`, '_blank');
													}}>
													<i class='fas fa-download'></i>
												</button>

												<button
													type='button'
													class='btn btn-flat btn-outline-danger'
													style={{ width: '48%' }}
													disabled={readOnly}
													onClick={() => {
														this.props.initForm({
															...this.props.formularioValues,
															anexos: this.props.formularioValues.anexos.filter(item => item != arquivo)
														});
													}}>
													<i class='fas fa-trash-alt'></i>
												</button>
											</div>
										</div>
									))}
									{!readOnly ? (
										<span class="btn btn-outline-primary fileinput-button dz-clickable" onClick={() => this.fileSelectorAnexo.click()}>
											<img src={pdfAdd} style={{ height: 30 }} />
										</span>
									) : null}
								</Row>

							</Grid>
						</Row>}
					</ContentCardBody>
					
					{!this.props.convenio &&
					<ContentCardFooter>
						<Row alignCenter>
							{!this.props.excluir &&
							<Grid cols='6 6 4 3'>
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
							</Grid>}
							{this.props.excluir &&
							<Grid cols='6 6 4 3'>
								<Button
									text='Excluir'
									submit type={'danger'}
									icon={'fa fa-trash'} />
							</Grid>}
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>}
				</Form>

				{(this.props.convenio && this.props.formularioValues.id) &&
				<div>
					<ContratoItem 
						id_contrato={this.props.formularioValues.id}
						ids_grupo_faturamento={this.props.formularioValues.ids_grupo_faturamento}
						id_hospital={this.props.formularioValues.id_hospital} />
				</div>}

				{(this.props.convenio && this.props.formularioValues.id) &&
				<div>
					<ContratoServico
						id_contrato={this.props.formularioValues.id}
						ids_grupo_faturamento={this.props.formularioValues.ids_grupo_faturamento}
						id_hospital={this.props.formularioValues.id_hospital} />
				</div>}

			</ContentCard>
		);
    }


}

ContratoForm = reduxForm({form: 'contratoForm', destroyOnUnmount: false})(ContratoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('contratoForm')(state),
	registro: state.contrato.registro,
	listaGrupoFaturamento: state.grupoFaturamento.listaSelect,
	listaHospital: state.hospital.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ContratoForm);
